import './index.scss';
import 'components/button_follow';
import 'components/freemium/block_message';
import 'components/video_player';
import 'styles/components/_responsive-embed.scss';
import { updateFreemiumCounter } from 'utils/freemium';

export default class LessonPlayerMjolnir {
  static start(context) {
    LessonPlayerMjolnir._bind(context);

    if (gon.flags.freemium_lessons) {
      LessonPlayerMjolnir._bindFreemiumEvents(context);
    }
  }

  static _bind(context) {
  }

  static _bindFreemiumEvents(context) {
    $(context).on('play', 'stream.js-video-player', function(event) {
      const $video = $(this);
      const { resourceType, eventEmitted } = $video.data();

      if (eventEmitted || resourceType !== 'lessons') {
        return;
      }

      $video.data('eventEmitted', true);

      const $lesson = $video.closest('.q-track-video');
      $lesson.addClass('lesson-opened');
     
      updateFreemiumCounter('lessons');
    });
  }
} 